import HTMLHead from "../../components/blocks/HTMLHead";
import MetaElement from "../../components/elements/MetaElement";

const BurstProtocolLanding = () => {
    const products = [
        {
            name: "Booster Display (24 Packs)",
            price: "369.99",
            image: "https://content.krit.ro/public-assets/landing-assets/burst-protocol-premiere/bpro-booster-display.png",
            url: "https://krit.ro/produs/yu-gi-oh-tcg-burst-protocol-booster-display-24-boosters",
            badge: "DISPLAY",
            soldOut: false
        },
        {
            name: "Booster Pack",
            price: "15.99",
            image: "https://content.krit.ro/public-assets/landing-assets/burst-protocol-premiere/BPRO-Foil-Single-550x550-1.png",
            url: "https://krit.ro/produs/yu-gi-oh-tcg-burst-protocol-booster-pack",
            badge: null,
            soldOut: false
        }
    ];

    const events = [
        {
            title: "Premiere! Ploiești",
            date: "Sâmbătă, 31 Ianuarie 2026",
            time: "13:00",
            location: "KRIT Ploiești",
            address: "Str. Buna Vestire, Nr. 55, Ploiești",
            locationLogo: "https://content.krit.ro/public-assets/other-resource/krit_preview_ploiesti_rev3.png",
            price: "79 LEI",
            url: "https://krit.ro/calendar/event/yu-gi-oh-burst-protocol-premiere-ploiesti-2026-01-31",
            soldOut: false
        },
        {
            title: "Premiere! Brașov",
            date: "Duminică, 1 Februarie 2026",
            time: "13:00",
            location: "KRIT Brașov",
            address: "Str. Lunga, Nr. 51, Brașov",
            locationLogo: "https://content.krit.ro/public-assets/other-resource/krit_preview_brasov_rev3.png",
            price: "79 LEI",
            url: "https://krit.ro/calendar/event/yu-gi-oh-burst-protocol-premiere-2026-02-01",
            soldOut: false
        }
    ];

    return (
        <>
            <HTMLHead />
            <MetaElement pageId="landing/ygo-burst-protocol" />

            <style global jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Roboto:wght@400;500;700;900&display=swap');

                :root {
                    --ygo-gold: #d4af37;
                    --ygo-gold-dark: #b8960c;
                    --ygo-red: #c41e3a;
                    --ygo-red-dark: #8b0000;
                    --ygo-blue: #1e90ff;
                    --ygo-purple: #8b008b;
                    --ygo-dark: #1a1a2e;
                    --ygo-darker: #0f0f1a;
                    --ygo-black: #0a0a0f;
                    --text-white: #ffffff;
                    --text-light: #e0e0e0;
                    --text-muted: #a0a0a0;
                }

                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                html, body, #__next {
                    background-color: var(--ygo-black);
                    scroll-behavior: smooth;
                }

                .landing-container {
                    width: 100%;
                    min-height: 100vh;
                    font-family: 'Roboto', sans-serif;
                    color: var(--text-white);
                    overflow-x: hidden;
                }

                /* KRIT Badge */
                .krit-badge {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    z-index: 1000;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 6px;
                    text-decoration: none;
                    transition: transform 0.3s ease;
                }

                .krit-badge:hover {
                    transform: scale(1.05);
                }

                .krit-badge-logo {
                    height: 55px;
                    width: auto;
                    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.8));
                }

                .krit-badge-text {
                    font-family: 'Roboto', sans-serif;
                    font-size: 0.8rem;
                    font-weight: 700;
                    color: var(--ygo-gold);
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    background: rgba(0, 0, 0, 0.85);
                    padding: 6px 14px;
                    border-radius: 4px;
                    border: 2px solid var(--ygo-gold);
                }

                /* Hero Section */
                .hero {
                    position: relative;
                    width: 100%;
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background:
                        linear-gradient(180deg,
                            rgba(10, 10, 15, 0.4) 0%,
                            rgba(10, 10, 15, 0.6) 50%,
                            rgba(10, 10, 15, 0.95) 100%),
                        url('https://content.krit.ro/public-assets/landing-assets/burst-protocol-premiere/header_background.jpg');
                    background-size: cover;
                    background-position: center top;
                    padding: 60px 20px;
                }

                .hero-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    max-width: 1000px;
                    z-index: 10;
                }

                @keyframes glowPulse {
                    0%, 100% {
                        filter: drop-shadow(0 4px 20px rgba(212, 175, 55, 0.4)) drop-shadow(0 0 30px rgba(212, 175, 55, 0.3));
                    }
                    50% {
                        filter: drop-shadow(0 4px 30px rgba(212, 175, 55, 0.7)) drop-shadow(0 0 50px rgba(212, 175, 55, 0.5));
                    }
                }

                @keyframes shimmer {
                    0% {
                        background-position: -200% center;
                    }
                    100% {
                        background-position: 200% center;
                    }
                }

                @keyframes energyWave {
                    0% {
                        transform: translateY(-100%) scaleX(1.2);
                        opacity: 0;
                    }
                    50% {
                        opacity: 0.3;
                    }
                    100% {
                        transform: translateY(100vh) scaleX(1.5);
                        opacity: 0;
                    }
                }

                @keyframes floatParticle {
                    0% {
                        transform: translateY(0) translateX(0) rotate(0deg);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    90% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(-100vh) translateX(50px) rotate(180deg);
                        opacity: 0;
                    }
                }

                .hero::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(
                        90deg,
                        transparent 0%,
                        rgba(212, 175, 55, 0.05) 25%,
                        rgba(212, 175, 55, 0.1) 50%,
                        rgba(212, 175, 55, 0.05) 75%,
                        transparent 100%
                    );
                    background-size: 200% 100%;
                    animation: energyWave 8s ease-in-out infinite;
                    pointer-events: none;
                    z-index: 1;
                }

                .hero::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-image:
                        radial-gradient(2px 2px at 20% 30%, rgba(212, 175, 55, 0.4), transparent),
                        radial-gradient(2px 2px at 60% 70%, rgba(212, 175, 55, 0.3), transparent),
                        radial-gradient(1px 1px at 50% 50%, rgba(212, 175, 55, 0.5), transparent),
                        radial-gradient(1px 1px at 80% 10%, rgba(212, 175, 55, 0.4), transparent),
                        radial-gradient(2px 2px at 90% 60%, rgba(212, 175, 55, 0.3), transparent),
                        radial-gradient(1px 1px at 33% 80%, rgba(212, 175, 55, 0.4), transparent);
                    background-size: 200% 200%;
                    animation: floatParticle 15s linear infinite;
                    pointer-events: none;
                    z-index: 1;
                }

                .yugioh-logo {
                    width: 100%;
                    max-width: 320px;
                    margin-bottom: 30px;
                    animation: glowPulse 3s ease-in-out infinite;
                    transition: transform 0.3s ease;
                }

                .yugioh-logo:hover {
                    transform: scale(1.05);
                }

                .bpro-logo {
                    width: 100%;
                    max-width: 450px;
                    margin-bottom: 25px;
                    animation: glowPulse 4s ease-in-out infinite 0.5s;
                    transition: transform 0.3s ease;
                }

                .bpro-logo:hover {
                    transform: scale(1.05) rotate(1deg);
                }

                .premiere-banner {
                    position: relative;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    background: linear-gradient(135deg, var(--ygo-red) 0%, var(--ygo-red-dark) 100%);
                    padding: 15px 35px;
                    border-radius: 0;
                    margin-bottom: 25px;
                    clip-path: polygon(10px 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
                    box-shadow: 0 8px 30px rgba(196, 30, 58, 0.5);
                    overflow: hidden;
                }

                .premiere-banner::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(
                        90deg,
                        transparent 0%,
                        rgba(255, 255, 255, 0.3) 50%,
                        transparent 100%
                    );
                    background-size: 200% 100%;
                    animation: shimmer 3s linear infinite;
                    pointer-events: none;
                }

                .ots-logo {
                    height: 50px;
                    width: auto;
                }

                .premiere-text {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 1.8rem;
                    letter-spacing: 3px;
                    color: var(--text-white);
                }

                .premiere-dates {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 2.5rem;
                    color: var(--ygo-gold);
                    letter-spacing: 2px;
                    margin-bottom: 15px;
                    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.8);
                }

                .hero-subtitle {
                    font-size: 1.15rem;
                    color: var(--text-light);
                    max-width: 650px;
                    line-height: 1.7;
                    margin-bottom: 35px;
                }

                .hero-buttons {
                    display: flex;
                    gap: 20px;
                    flex-wrap: wrap;
                    justify-content: center;
                }

                .btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 16px 40px;
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 1.3rem;
                    letter-spacing: 2px;
                    text-decoration: none;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    border: none;
                    clip-path: polygon(8px 0, 100% 0, calc(100% - 8px) 100%, 0 100%);
                }

                .btn-primary {
                    background: linear-gradient(135deg, var(--ygo-gold) 0%, var(--ygo-gold-dark) 100%);
                    color: var(--ygo-black);
                }

                .btn-primary:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 30px rgba(212, 175, 55, 0.5);
                }

                .btn-secondary {
                    background: transparent;
                    color: var(--text-white);
                    border: 3px solid var(--ygo-gold);
                    clip-path: none;
                }

                .btn-secondary:hover {
                    background: rgba(212, 175, 55, 0.15);
                    transform: translateY(-3px);
                }

                /* Scroll Indicator */
                .scroll-indicator {
                    position: absolute;
                    bottom: 30px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 8px;
                    color: var(--text-muted);
                    font-size: 0.8rem;
                    animation: bounce 2s infinite;
                }

                @keyframes bounce {
                    0%, 100% { transform: translateX(-50%) translateY(0); }
                    50% { transform: translateX(-50%) translateY(8px); }
                }

                .scroll-indicator svg {
                    width: 24px;
                    height: 24px;
                }

                /* Section Styles */
                .section {
                    padding: 80px 20px;
                    max-width: 1300px;
                    margin: 0 auto;
                }

                .section-header {
                    text-align: center;
                    margin-bottom: 50px;
                }

                .section-title {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 3rem;
                    letter-spacing: 4px;
                    color: var(--text-white);
                    margin-bottom: 15px;
                }

                .section-title span {
                    color: var(--ygo-gold);
                }

                .section-subtitle {
                    font-size: 1.1rem;
                    color: var(--text-muted);
                    max-width: 700px;
                    margin: 0 auto;
                    line-height: 1.6;
                }



                /* Events Section */
                .events-section {
                    background: var(--ygo-dark);
                    position: relative;
                    overflow: hidden;
                }

                .events-section::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 4px;
                    background: linear-gradient(90deg, transparent, var(--ygo-gold), transparent);
                }

                .events-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
                    gap: 30px;
                }

                .event-card {
                    background: var(--ygo-darker);
                    border: 3px solid rgba(212, 175, 55, 0.4);
                    overflow: hidden;
                    transition: all 0.3s ease;
                    position: relative;
                    box-shadow: 0 0 30px rgba(212, 175, 55, 0.15), inset 0 0 50px rgba(212, 175, 55, 0.05);
                }

                .event-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(212, 175, 55, 0.1), transparent);
                    transition: left 0.5s ease;
                }

                .event-card:hover {
                    border-color: var(--ygo-gold);
                    box-shadow: 0 0 60px rgba(212, 175, 55, 0.4), 0 10px 40px rgba(0, 0, 0, 0.5), inset 0 0 60px rgba(212, 175, 55, 0.1);
                    transform: translateY(-5px);
                }

                .event-card:hover::before {
                    left: 100%;
                }

                .event-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 20px;
                    background: linear-gradient(135deg, var(--ygo-red) 0%, var(--ygo-red-dark) 100%);
                }

                .event-header.ploiesti {
                    background: linear-gradient(135deg, #ff6b35 0%, #e55b25 100%);
                }

                .event-header.brasov {
                    background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%);
                }

                .event-title {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 1.6rem;
                    letter-spacing: 2px;
                    color: var(--text-white);
                }

                .event-location-logo {
                    height: 45px;
                    width: auto;
                    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.6));
                }

                .event-body {
                    padding: 25px;
                }

                .event-detail {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    margin-bottom: 18px;
                    color: var(--text-light);
                }

                .event-detail:last-of-type {
                    margin-bottom: 0;
                }

                .event-icon {
                    width: 28px;
                    height: 28px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.2rem;
                    color: var(--ygo-gold);
                }

                .event-detail-text {
                    font-size: 1rem;
                }

                .event-detail-text strong {
                    color: var(--text-white);
                    font-weight: 700;
                }

                .event-footer {
                    padding: 0 25px 25px;
                }

                @keyframes pulseGlow {
                    0%, 100% {
                        box-shadow: 0 0 20px rgba(212, 175, 55, 0.4), 0 0 40px rgba(212, 175, 55, 0.2), inset 0 0 20px rgba(212, 175, 55, 0.1);
                    }
                    50% {
                        box-shadow: 0 0 30px rgba(212, 175, 55, 0.6), 0 0 60px rgba(212, 175, 55, 0.3), inset 0 0 30px rgba(212, 175, 55, 0.2);
                    }
                }

                @keyframes scanline {
                    0% {
                        transform: translateY(-100%);
                    }
                    100% {
                        transform: translateY(100%);
                    }
                }

                .event-btn {
                    display: block;
                    width: 100%;
                    padding: 18px;
                    background: linear-gradient(135deg, var(--ygo-gold) 0%, var(--ygo-gold-dark) 100%);
                    color: var(--ygo-black);
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 1.3rem;
                    letter-spacing: 3px;
                    text-align: center;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    border: none;
                    position: relative;
                    overflow: hidden;
                    animation: pulseGlow 2s ease-in-out infinite;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
                    font-weight: 900;
                }

                .event-btn::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 2px;
                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
                    animation: scanline 2s linear infinite;
                }

                .event-btn::after {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background: linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.2) 50%, transparent 70%);
                    background-size: 200% 200%;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                .event-btn:hover {
                    box-shadow: 0 0 40px rgba(212, 175, 55, 0.8), 0 8px 30px rgba(212, 175, 55, 0.5), inset 0 0 30px rgba(212, 175, 55, 0.3);
                    transform: translateY(-3px) scale(1.02);
                    letter-spacing: 4px;
                }

                .event-btn:hover::after {
                    opacity: 1;
                    animation: shimmer 0.6s ease;
                }

                .event-btn.sold-out {
                    background: linear-gradient(135deg, #555 0%, #333 100%);
                    color: #888;
                    cursor: not-allowed;
                }

                /* Products Section */
                .products-section {
                    background: var(--ygo-black);
                }

                .products-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                    gap: 40px;
                    max-width: 800px;
                    margin: 0 auto;
                }

                .product-card {
                    background: linear-gradient(180deg, var(--ygo-darker) 0%, var(--ygo-dark) 100%);
                    border: 2px solid rgba(212, 175, 55, 0.2);
                    overflow: hidden;
                    position: relative;
                    transition: all 0.3s ease;
                }

                .product-card:hover {
                    border-color: var(--ygo-gold);
                    box-shadow: 0 0 50px rgba(212, 175, 55, 0.15);
                }

                .product-badge {
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    background: var(--ygo-red);
                    color: var(--text-white);
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 0.9rem;
                    letter-spacing: 2px;
                    padding: 6px 15px;
                    z-index: 10;
                }

                .product-image-wrapper {
                    position: relative;
                    width: 100%;
                    padding-top: 100%;
                    background: linear-gradient(135deg, rgba(40, 40, 60, 0.5) 0%, rgba(20, 20, 35, 0.5) 100%);
                }

                .product-image {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 80%;
                    height: 80%;
                    object-fit: contain;
                    transition: transform 0.3s ease;
                }

                .product-card:hover .product-image {
                    transform: translate(-50%, -50%) scale(1.08);
                }

                .product-info {
                    padding: 30px;
                    text-align: center;
                    border-top: 1px solid rgba(212, 175, 55, 0.2);
                }

                .product-name {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 1.5rem;
                    letter-spacing: 2px;
                    color: var(--text-white);
                    margin-bottom: 10px;
                }

                .product-price {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 2rem;
                    color: var(--ygo-gold);
                    margin-bottom: 20px;
                }

                .product-price span {
                    font-size: 1rem;
                    color: var(--text-muted);
                }

                .product-btn {
                    display: inline-block;
                    padding: 14px 35px;
                    background: transparent;
                    color: var(--ygo-gold);
                    border: 2px solid var(--ygo-gold);
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 1.1rem;
                    letter-spacing: 2px;
                    text-decoration: none;
                    transition: all 0.3s ease;
                }

                .product-btn:hover {
                    background: var(--ygo-gold);
                    color: var(--ygo-black);
                }

                .product-note {
                    text-align: center;
                    margin-top: 10px;
                    font-size: 0.85rem;
                    color: var(--ygo-gold);
                    font-style: italic;
                }

                /* Gamemat Showcase Section */
                .gamemat-section {
                    background: var(--ygo-black);
                    padding: 80px 20px;
                    position: relative;
                    overflow: hidden;
                }

                .gamemat-section::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 2px;
                    background: linear-gradient(90deg, transparent, var(--ygo-gold), transparent);
                }

                .gamemat-content {
                    max-width: 1200px;
                    margin: 0 auto;
                    text-align: center;
                }

                .gamemat-images {
                    display: flex;
                    gap: 20px;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 30px;
                    flex-wrap: wrap;
                }

                .gamemat-images {
                    display: flex;
                    gap: 20px;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 30px;
                    flex-wrap: wrap;
                }

                .gamemat-image {
                    width: 100%;
                    max-width: 500px;
                    transition: all 0.3s ease;
                    flex: 1 1 400px;
                }

                .gamemat-image:hover {
                    transform: scale(1.02);
                }

                .gamemat-title {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 2.2rem;
                    letter-spacing: 3px;
                    color: var(--ygo-gold);
                    margin-bottom: 15px;
                    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.8);
                }

                .gamemat-text {
                    font-size: 1.1rem;
                    color: var(--text-light);
                    line-height: 1.7;
                    max-width: 650px;
                    margin: 0 auto;
                }

                /* Info Section */
                .info-section {
                    background: linear-gradient(180deg, var(--ygo-dark) 0%, var(--ygo-darker) 100%);
                    position: relative;
                }

                .info-section::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 4px;
                    background: linear-gradient(90deg, transparent, var(--ygo-gold), transparent);
                }

                .info-content {
                    max-width: 900px;
                    margin: 0 auto;
                    text-align: center;
                }

                .info-promo-image {
                    width: 100%;
                    max-width: 600px;
                    margin-bottom: 40px;
                    border: 3px solid var(--ygo-gold);
                }

                .info-title {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 2.5rem;
                    letter-spacing: 3px;
                    color: var(--ygo-gold);
                    margin-bottom: 20px;
                }

                .info-text {
                    font-size: 1.1rem;
                    color: var(--text-light);
                    line-height: 1.8;
                    margin-bottom: 35px;
                }

                .info-highlights {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    gap: 15px;
                }

                .info-highlight {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    background: rgba(212, 175, 55, 0.1);
                    border: 1px solid rgba(212, 175, 55, 0.3);
                    padding: 12px 20px;
                    font-size: 0.95rem;
                    color: var(--text-white);
                }

                .info-highlight::before {
                    content: '★';
                    color: var(--ygo-gold);
                    font-size: 1.1rem;
                }

                /* Set Contents */
                .set-contents {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 20px;
                    margin-top: 50px;
                }

                .set-stat {
                    background: rgba(30, 30, 50, 0.6);
                    border: 1px solid rgba(212, 175, 55, 0.2);
                    padding: 25px;
                    text-align: center;
                }

                .set-stat-number {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 2.5rem;
                    color: var(--ygo-gold);
                    margin-bottom: 5px;
                }

                .set-stat-label {
                    font-size: 0.9rem;
                    color: var(--text-muted);
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }

                /* Footer */
                .footer {
                    background: var(--ygo-black);
                    padding: 60px 20px;
                    text-align: center;
                    border-top: 1px solid rgba(212, 175, 55, 0.2);
                }

                .footer-logo {
                    width: 180px;
                    margin: 0 auto 25px;
                    display: block;
                }

                .footer-text {
                    font-size: 1rem;
                    color: var(--text-muted);
                    margin-bottom: 25px;
                    line-height: 1.6;
                }

                .footer-links {
                    display: flex;
                    justify-content: center;
                    gap: 35px;
                    flex-wrap: wrap;
                    margin-bottom: 40px;
                }

                .footer-link {
                    color: var(--ygo-gold);
                    text-decoration: none;
                    font-weight: 500;
                    transition: color 0.3s ease;
                }

                .footer-link:hover {
                    color: var(--text-white);
                }

                .copyright {
                    font-size: 0.8rem;
                    color: var(--text-muted);
                    padding-top: 25px;
                    border-top: 1px solid rgba(255, 255, 255, 0.1);
                }

                /* Responsive */
                @media (max-width: 1024px) {
                    .highlights-grid {
                        grid-template-columns: 1fr;
                    }

                    .set-contents {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }

                @media (max-width: 768px) {
                    .krit-badge {
                        display: none;
                    }

                    .hero {
                        min-height: auto;
                        padding: 80px 20px 60px;
                    }

                    .yugioh-logo {
                        max-width: 220px;
                    }

                    .bpro-logo {
                        max-width: 320px;
                    }

                    .premiere-banner {
                        flex-direction: column;
                        gap: 10px;
                        padding: 15px 25px;
                    }

                    .premiere-text {
                        font-size: 1.4rem;
                    }

                    .premiere-dates {
                        font-size: 1.8rem;
                    }

                    .hero-subtitle {
                        font-size: 1rem;
                    }

                    .hero-buttons {
                        flex-direction: column;
                        width: 100%;
                        max-width: 300px;
                    }

                    .btn {
                        width: 100%;
                    }

                    .section {
                        padding: 60px 20px;
                    }

                    .section-title {
                        font-size: 2.2rem;
                    }

                    .gamemat-section {
                        padding: 60px 20px;
                    }

                    .gamemat-title {
                        font-size: 1.8rem;
                    }

                    .gamemat-text {
                        font-size: 1rem;
                    }

                    .events-grid {
                        grid-template-columns: 1fr;
                    }

                    .products-grid {
                        grid-template-columns: 1fr;
                    }

                    .info-title {
                        font-size: 2rem;
                    }

                    .set-contents {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 15px;
                    }

                    .set-stat {
                        padding: 20px 15px;
                    }

                    .set-stat-number {
                        font-size: 2rem;
                    }

                    .scroll-indicator {
                        display: none;
                    }
                }

                @media (max-width: 480px) {
                    .bpro-logo {
                        max-width: 260px;
                    }

                    .footer-links {
                        flex-direction: column;
                        gap: 15px;
                    }
                }
            `}</style>

            {/* JSON-LD Structured Data */}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Event",
                        "name": "Yu-Gi-Oh! Burst Protocol Premiere!",
                        "description": "Participă la evenimentele Premiere! pentru Yu-Gi-Oh! TCG Burst Protocol. Evenimente disponibile în Ploiești și Brașov.",
                        "startDate": "2026-01-31T13:00:00+02:00",
                        "endDate": "2026-02-01T20:00:00+02:00",
                        "eventStatus": "https://schema.org/EventScheduled",
                        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                        "image": "https://content.krit.ro/public-assets/landing-assets/burst-protocol-premiere/header_background.jpg",
                        "location": [
                            {
                                "@type": "Place",
                                "name": "KRIT Ploiești",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "Str. Buna Vestire, Nr. 55",
                                    "addressLocality": "Ploiești",
                                    "addressCountry": "RO"
                                }
                            },
                            {
                                "@type": "Place",
                                "name": "KRIT Brașov",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "Str. Lunga, Nr. 51",
                                    "addressLocality": "Brașov",
                                    "addressCountry": "RO"
                                }
                            }
                        ],
                        "organizer": {
                            "@type": "Organization",
                            "name": "KRIT - Board Games & Card Games",
                            "url": "https://krit.ro",
                            "logo": "https://content.krit.ro/public-assets/landing-assets/logo.png"
                        },
                        "offers": {
                            "@type": "AggregateOffer",
                            "lowPrice": "19.99",
                            "highPrice": "449.00",
                            "priceCurrency": "RON",
                            "availability": "https://schema.org/InStock",
                            "url": "https://krit.ro/landing/ygo-burst-protocol"
                        }
                    })
                }}
            />

            <div className="landing-container">
                {/* KRIT Badge */}
                <a href="https://krit.ro" className="krit-badge" target="_blank" rel="noopener noreferrer">
                    <img
                        src="https://content.krit.ro/public-assets/landing-assets/logo.png"
                        alt="KRIT Logo"
                        className="krit-badge-logo"
                    />
                    <span className="krit-badge-text">Înapoi la site</span>
                </a>

                {/* Hero Section */}
                <section className="hero">
                    <div className="hero-content">
                        <img
                            src="https://content.krit.ro/public-assets/landing-assets/burst-protocol-premiere/Yugioh-EN-DE.svg"
                            alt="Yu-Gi-Oh! Trading Card Game"
                            className="yugioh-logo"
                        />
                        <img
                            src="https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/bpro-logo.png"
                            alt="Burst Protocol"
                            className="bpro-logo"
                        />

                        <div className="premiere-banner">
                            <img
                                src="https://content.krit.ro/public-assets/landing-assets/burst-protocol-premiere/ots-logo-450px.webp"
                                alt="Official Tournament Store"
                                className="ots-logo"
                            />
                            <span className="premiere-text">PREMIERE! EVENT</span>
                        </div>

                        <p className="premiere-dates">31 IANUARIE – 1 FEBRUARIE 2026</p>

                        <p className="hero-subtitle">
                            Obține cărțile din Burst Protocol înainte de lansarea oficială!
                            Intrarea este 79 LEI. Toți participanții intră la raffle pentru game mat-ul exclusiv si cartea promo!
                        </p>

                        <div className="hero-buttons">
                            <a href="#events" className="btn btn-primary">PARTICIPĂ LA PREMIERE!</a>
                            <a href="#products" className="btn btn-secondary">VEZI PRODUSELE</a>
                        </div>
                    </div>

                    <div className="scroll-indicator">
                        <span>Scroll</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>
                </section>

                {/* Events Section */}
                <section className="events-section" id="events">
                    <div className="section">
                        <div className="section-header">
                            <h2 className="section-title">EVENIMENTE <span>PREMIERE!</span></h2>
                            <p className="section-subtitle">
                                Fii printre primii care deschid Burst Protocol! Alege locația și vino să joci!
                            </p>
                        </div>

                        <div className="events-grid">
                            {events.map((event, index) => {
                                const locationClass = event.location.includes('Ploiești') ? 'ploiesti' : 'brasov';
                                return (
                                    <div className={`event-card ${event.soldOut ? 'sold-out' : ''}`} key={index}>
                                        <div className={`event-header ${locationClass}`}>
                                            <span className="event-title">{event.title}</span>
                                            <img
                                                src={event.locationLogo}
                                                alt={event.location}
                                                className="event-location-logo"
                                            />
                                        </div>
                                        <div className="event-body">
                                            <div className="event-detail">
                                                <span className="event-icon">📅</span>
                                                <span className="event-detail-text">{event.date}</span>
                                            </div>
                                            <div className="event-detail">
                                                <span className="event-icon">🕐</span>
                                                <span className="event-detail-text">Ora <strong>{event.time}</strong></span>
                                            </div>
                                            <div className="event-detail">
                                                <span className="event-icon">📍</span>
                                                <span className="event-detail-text">{event.address}</span>
                                            </div>
                                            <div className="event-detail">
                                                <span className="event-icon">💰</span>
                                                <span className="event-detail-text"><strong>{event.price}</strong> (5 Boosters)</span>
                                            </div>
                                        </div>
                                        <div className="event-footer">
                                            {event.soldOut ? (
                                                <span className="event-btn sold-out">SOLD OUT</span>
                                            ) : (
                                                <a href={event.url} className="event-btn">ÎNSCRIE-TE ACUM</a>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>

                {/* Products Section */}
                <section className="products-section" id="products">
                    <div className="section">
                        <div className="section-header">
                            <h2 className="section-title">PRODUSE <span>BURST PROTOCOL</span></h2>
                            <p className="section-subtitle">
                                Precomandă acum! Lansare oficială: 6 Februarie 2026.
                            </p>
                        </div>

                        <div className="products-grid">
                            {products.map((product, index) => (
                                <div className={`product-card ${product.soldOut ? 'sold-out' : ''}`} key={index}>
                                    {product.badge && (
                                        <span className="product-badge">{product.badge}</span>
                                    )}
                                    <div className="product-image-wrapper">
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            className="product-image"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="product-info">
                                        <h3 className="product-name">{product.name}</h3>
                                        <p className="product-price">
                                            {product.price} <span>LEI</span>
                                        </p>
                                        {product.soldOut ? (
                                            <span className="product-btn sold-out">INDISPONIBIL</span>
                                        ) : (
                                            <>
                                                <a href={product.url} className="product-btn">PRECOMANDĂ ACUM</a>
                                                <p className="product-note">Disponibil și la Premiere!</p>
                                            </>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div style={{ textAlign: 'center', marginTop: '50px' }}>
                            <a href="https://krit.ro/cautare/burst%2Bprotocol" className="btn btn-secondary">
                                VEZI TOATE PRODUSELE YU-GI-OH!
                            </a>
                        </div>
                    </div>
                </section>

                {/* Gamemat Showcase */}
                <section className="gamemat-section">
                    <div className="section">
                        <div className="gamemat-content">
                            <div className="gamemat-images">
                                <img
                                    src="https://content.krit.ro/public-assets/landing-assets/burst-protocol-premiere/TCG-BPRO_Premiere_fan-768x532.webp"
                                    alt="Burst Protocol Premiere Game Mat"
                                    className="gamemat-image"
                                />
                                <img
                                    src="https://content.krit.ro/public-assets/landing-assets/burst-protocol-premiere/TCG-BPRO-GM_FCC_Sample_2025-768x420.webp"
                                    alt="Burst Protocol Field Center Card"
                                    className="gamemat-image"
                                />
                            </div>
                            <h3 className="gamemat-title">PARTICIPĂ ȘI CÂȘTIGĂ PREMII EXCLUSIVE!</h3>
                            <p className="gamemat-text">
                                La evenimentul Premiere! primești 5 pachete Burst Protocol și intri automat în tragerea la sorți pentru Game Mat SAU Promo Card!
                            </p>
                        </div>
                    </div>
                </section>

                {/* Info Section */}
                <section className="info-section">
                    <div className="section">
                        <div className="info-content">
                            <h2 className="info-title">CE ESTE PREMIERE! EVENT?</h2>
                            <p className="info-text">
                                Premiere! Event este evenimentul oficial de prerelease Konami care îți oferă acces
                                la noul set Burst Protocol cu 1 săptămână înainte de lansarea oficială!
                                Primești automat 5 pachete Burst Protocol, un Field Center Card exclusiv și intri
                                în tragerea la sorți pentru Game Mat SAU carte Secret Rare promoțională!
                            </p>

                            <div className="info-highlights">
                                <div className="info-highlight">Acces anticipat la Burst Protocol</div>
                                <div className="info-highlight">Field Center Card exclusiv</div>
                                <div className="info-highlight">Șansă la Game Mat SAU Promo Card</div>
                            </div>

                            <div className="set-contents">
                                <div className="set-stat">
                                    <div className="set-stat-number">10</div>
                                    <div className="set-stat-label">Secret Rares</div>
                                </div>
                                <div className="set-stat">
                                    <div className="set-stat-number">14</div>
                                    <div className="set-stat-label">Ultra Rares</div>
                                </div>
                                <div className="set-stat">
                                    <div className="set-stat-number">26</div>
                                    <div className="set-stat-label">Super Rares</div>
                                </div>
                                <div className="set-stat">
                                    <div className="set-stat-number">50</div>
                                    <div className="set-stat-label">Commons</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <p className="px-5 py-6 text-center text-xs text-slate-400">Yu-Gi-Oh! și Burst Protocol sunt mărci înregistrate ale Konami Digital Entertainment.</p>
            </div>
        </>
    );
};

export default BurstProtocolLanding;
